import api from '@/services/api';

export const validateZipCode = async (zip) => {
  const { data } = await api.get(`/v0/public/v1/zip/${zip}`);
  return data;
};

export default { validateZipCode };
